var e = "object" == typeof Deno && Deno && "object" == typeof Deno.version;
export { e };